import SectionHeading from "./SectionHeading";
import AboutImage from "../../Assets/Images/abt_story.png"; // Replace with actual path
function AboutStory() {
    return (
        <div  className="about-story">
            <SectionHeading
                secTitle="Our Story"
            />
            <div className="container-fluid">
                <div className="row  align-items-center pb-4">
                    <div className="col-12 col-lg-6 col-xl-4 pb-4">
                        <img src={AboutImage} alt="About Us" className="img-fluid" />
                    </div>
                    <div className="col-12 col-lg-6 col-xl-6 ps-lg-5">
                        <p>Established in 2023, we set out on our event management journey with a mission to craft meaningful, smooth, and extraordinary experiences. Our first event was a huge success, setting the tone for an inspiring journey ahead. Within two years, we have successfully conducted five consecutive large-scale events and actively engaged in more than 20 high-profile gatherings, establishing our expertise and industry presence This fast growth has not only enhanced our confidence but also honed our method, enabling us to perfect. </p>
                    </div>
                </div>
                <p>The Art of event planning and management. With diligent attention to detail, creative approaches, and steadfast commitment, we have established close relationships with industry professionals, experts, public figures, and business leaders. Our reputation as a reliable event management company is due to our capability to combine creativity, precision, and professionalism to create unforgettable experiences.</p>
                <p>As we keep growing, our passion for excellence is always at the center of what we do. Whether corporate conventions, book launch parties, or mega exhibitions, we make sure that every event we organize leaves a mark. With an obsession for perfection and an enthusiasm for innovation, we work towards bringing visions to life, making every event simply special.</p>
            </div>
        </div>
    );
}

export default AboutStory;
